import { render, staticRenderFns } from "./PlanComparison.vue?vue&type=template&id=aa3452e4&scoped=true&lang=pug"
import script from "./PlanComparison.vue?vue&type=script&lang=js"
export * from "./PlanComparison.vue?vue&type=script&lang=js"
import style0 from "./PlanComparison.vue?vue&type=style&index=0&id=aa3452e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3452e4",
  null
  
)

export default component.exports